module.exports = __webpack_public_path__ + "static/assets/f1fe0bbe960a0d60c783b111c84b837e.svg";